<template>
  <div class="text-13 min-h-6 flex items-center overflow-hidden">
    <template v-if="!payload.adapter_type">{{ $t('evaluate_editor.data-adapter') }}</template>
    <template v-else-if="payload.tools && payload.tools.length">
      <span class="truncate">{{ adapterName }}: {{ payload.tools.map((tool) => tool.name).join(', ') }}</span>
    </template>
    <template v-else>
      <span v-if="payload.variable"><VariableChip :name="payload.variable" :index="6" class="mr-1 text-12" /></span>
      <span v-if="payload.variable" class="text-pink-500 mr-1">{{ $t('equals') }}</span>
      <span class="truncate"
        >{{ adapterName }}<template v-if="payload.tool_name"> / {{ payload.tool_name }}</template></span
      >
    </template>
  </div>
</template>

<script>
import { DATA_ADAPTERS } from '@/constants';

export default {
  name: 'DataAdapterOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    payload() {
      return this.item.payload || {};
    },
    adapterName() {
      const type = this.payload.adapter_type;
      return (DATA_ADAPTERS[type] && DATA_ADAPTERS[type].name) || type;
    },
  },
};
</script>
